<template>
  <masonry :cols="{default: 4, 1200: 3, 1000: 2, 480: 1}" :gutter="20" class="m-20">
    <div class="item card-base card-alt m-2" :class="{'selected' : i.selected && selection}" v-for="(i, index) in images" :key="i.id">
      <Asset @click.native="selectImage(i.id, index)" :asset="i"></Asset>
      <div class="bg-info-lighter card-shadow--small p-5" style="margin-top:-5px; ">
        <el-row>
          <el-col :xs="buttonResponsiveWitdh" :sm="buttonResponsiveWitdh" :md="buttonResponsiveWitdh" :lg="buttonResponsiveWitdh" :xl="buttonResponsiveWitdh" class="text-center" v-if="edition">
            <el-button type="text" @click="handleEdition(i)" class="p-15 text-right"><i class="el-icon-edit fs-20"></i></el-button>
          </el-col>
          <el-col :xs="buttonResponsiveWitdh" :sm="buttonResponsiveWitdh" :md="buttonResponsiveWitdh" :lg="buttonResponsiveWitdh" :xl="buttonResponsiveWitdh" class="text-center" v-if="showInGalery">
            <el-button type="text" class="p-15 text-right" @click="show(index)"><i class="el-icon-search fs-20"></i></el-button>
          </el-col>
          <el-col :xs="buttonResponsiveWitdh" :sm="buttonResponsiveWitdh" :md="buttonResponsiveWitdh" :lg="buttonResponsiveWitdh" :xl="buttonResponsiveWitdh" class="text-center">
            <el-tooltip effect="dark" content="Dissocier cet élément du producteur" placement="top">
              <el-button  type="text" @click="handleDelete(i.id)" class="mr-10"><i class="mdi mdi-delete fs-20"></i></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
    </div>
  </masonry>
</template>
<script>

import moment from 'moment-timezone'
import Asset from './asset.vue'

export default {
	name: 'galery-masonry',
  props : {
    selection : {type : Boolean, default : false},
    multiple : {type : Boolean, default : false},
    showInGalery : {type : Boolean, default : false},
    edition : {type : Boolean, default : true},
    showCode : {type : Boolean, default : true},
    showDescription : {type : Boolean, default : true},
    images : {type : Array}
  },
	data() {
		return {

		}
	},
  components : {
    Asset
  },
  computed : {
    lang(){
      return this.$i18n.locale
    },
    buttonResponsiveWitdh(){
      let width = 1;
      if(this.showInGalery) width++;
      if(this.edition) width++;
      return 24/width;
    },
  },
  methods : {

    handleEdition(asset){
      this.$emit('edit', asset);
    },
    handleDelete(id){
      this.$emit('delete', id);
    },
    show(index){
      this.$emit('show',index);
    },

    selectImage(id, index){
      this.$emit('selectImage');
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
		}
  },
  mounted(){


  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';
.selected{
  opacity: 1;
  box-shadow: 0px 0px 0px 4px $text-color-accent !important
}
.masonry {
  column-count: 4;
  column-gap: 40px;
}

.item {
  //padding: 20px;
  //margin: 20px 0;
  margin-bottom: 20px;
  //border-radius: 5px;
  opacity: .85;
  transition: all .25s;

  /* masonry */
  //display: inline-block;
  // box-sizing: border-box;
  width: 100%;
  box-shadow: 0px 0px 0px 1px $text-color-accent;

  img {
    width: 100%;
    max-width: 100%;
  }

  &:hover {
    cursor:pointer;
    opacity: 1;
    box-shadow: 0px 0px 0px 4px $text-color-accent;
  }
}

/* Masonry on large screens */
@media (max-width: 1200px) {

	.masonry {
		column-count: 3;
	}

}

/* Masonry on medium-sized screens */
@media (max-width: 1000px) {
  .masonry {
    column-count: 2;
  }
}

/* Masonry on small screens */
@media (max-width: 480px) {
  .masonry {
    column-count: 1;
  }
}

</style>
